import { type Iteration } from '../models';
import RecordFilter from './RecordFilter';

class IterationFilter extends RecordFilter {
  matches(record: { iteration: Iteration }) {
    return super.matches(record.iteration);
  }
}

export default IterationFilter;
